import api from 'connections/api';
import routes_api from 'connections/routes_api';

// GET
export const getTrips = async () => {
  const response = await api.get(routes_api.travel_trips);
  return response.data;
};

export const getTripById = async (tripId) => {
  const response = await api.get(`${routes_api.travel_trips}${tripId}/`);
  return response.data;
};

// ##### Country Regions Mapping
export const getCountryRegions = async () => {
  try {
    const response = await api.get('/api/travel/country-regions/');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch country regions:', error);
    throw error;
  }
};

// CREATE AND DELETE
export const createTrip = async (data) => {
  try {
    const response = await api.post(routes_api.travel_trips, data);
    return response;
  } catch (error) {
    console.error('Failed to save trip:', error.response?.data || error.message);
    throw error;
  }
};

export const createManyTrips = (data) => {
  return api.post(routes_api.travel_trips_createmany, data);
};

export const deleteAllTrips = () => {
  return api.delete(routes_api.travel_trips_deleteall);
};

// UPDATE
export const updateTrip = async (tripId, data) => {
  const response = await api.put(`${routes_api.travel_trips}${tripId}/`, data);
  return response;
};

// DELETE
export const deleteTrip = async (tripId) => {
  try {
    const response = await api.delete(`${routes_api.travel_trips}${tripId}/`);
    return response;
  } catch (error) {
    console.error('Failed to delete trip:', error.response?.data || error.message);
    throw error;
  }
};

/** Upload trip cover image (JPEG/PNG/WebP, max 5MB). Field name: file */
export const uploadTripCover = async (tripId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(routes_api.travel_trip_cover(tripId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteTripCover = async (tripId) => {
  const response = await api.delete(routes_api.travel_trip_cover(tripId));
  return response.data;
};

export const getTravelEmbeddedNotepadCluster = async () => {
  return api.get(routes_api.travel_embedded_notepad_cluster);
};

export const patchTravelEmbeddedNotepadCluster = async (linkedNotepadClusterId) => {
  return api.patch(routes_api.travel_embedded_notepad_cluster, {
    linked_notepad_cluster_id: linkedNotepadClusterId,
  });
};
